import { render, staticRenderFns } from "./BasketArena.vue?vue&type=template&id=6b71a108&scoped=true"
import script from "./BasketArena.vue?vue&type=script&lang=js"
export * from "./BasketArena.vue?vue&type=script&lang=js"
import style0 from "./BasketArena.vue?vue&type=style&index=0&id=6b71a108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b71a108",
  null
  
)

export default component.exports